import * as React from "react";
import { useConnect } from "wagmi";
import { walletIcons } from "../../utils/constants";
import { useWalletConnect } from "../../context/wallet-connection";
import { useRootContext } from "../../context/app-context";
import { handleConnectSignMessage } from "../../utils/buttons.helper";
import useMetaMaskInstalled from "../../hooks/useMetaMaskInstalled";

export function WalletOptions({ iconCustomClass }) {
  const { isMetaMaskInstalled } = useMetaMaskInstalled();
  const { connectors } = useConnect();
  const { handleConnectWallet, loading, selectedWallet } = useWalletConnect();
  const { isSwitching, isMobile } = useRootContext();

  return connectors.map((connector) => (
    <li
      id={connector.id}
      className="p-5 md:px-8 md:py-6 bg-dim rounded-2xl flex items-center cursor-pointer"
      key={connector?.uid}
      onClick={() => handleConnectWallet(connector)}
    >
      {walletIcons[connector?.id]?.(iconCustomClass)}
      <span className="text-black txet-sm md:text-base font-medium text-vampireBlack/70">
        {handleConnectSignMessage(
          loading,
          selectedWallet,
          isSwitching,
          connector,
          false,
          false,
          isMetaMaskInstalled,
          isMobile
        )}
      </span>
    </li>
  ));
}
